import React, { useState, useRef, useEffect } from "react"

import ClickAwayListener from "@material-ui/core/ClickAwayListener"
import { IconButton, Zoom } from "@material-ui/core"
import Tooltip from "@material-ui/core/Tooltip"
import clsx from "clsx"

import * as styles from "./checkboxBlock.module.scss"
import { IconQuestion } from "../icons/IconQuestion"
import { IconClose } from "../icons/IconClose"
import { DLClickEventExtended } from "../../../../helpers/WatcherDL/DLEvents"

type CheckboxBlockProps = {
  checkboxActive: boolean
  onChangeCheckbox: () => void
}

const textBeforeTooltip = "С подпиской «Халва.Десятка»"

export const CheckboxBlock = ({ checkboxActive, onChangeCheckbox }: CheckboxBlockProps) => {
  const [openTooltip, setOpenTooltip] = useState(false)
  const tooltipRef = useRef<HTMLDivElement>(null)

  const handleTooltipClose = () => {
    setOpenTooltip(false)
  }

  const handleTooltipOpen = () => {
    DLClickEventExtended({
      name: "Tooltip",
      eventCategory: "click_tooltip",
      eventAction: textBeforeTooltip,
      placement: "calculator",
    })
    setOpenTooltip((prev) => !prev)
  }

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (openTooltip) {
      const handleScroll = () => {
        setOpenTooltip(false)
      }

      let scrollableContainer: any = tooltipRef.current?.closest('[style*="overflow"]')
      if (!scrollableContainer) {
        scrollableContainer = window
      }

      scrollableContainer.addEventListener("scroll", handleScroll)

      return () => {
        scrollableContainer.removeEventListener("scroll", handleScroll)
      }
    }
  }, [openTooltip])

  return (
    <div className={styles.checkboxBlock}>
      <label htmlFor="checkbox" className={styles.checkbox}>
        <input onChange={onChangeCheckbox} id="checkbox" type="checkbox" checked={checkboxActive} />
        <span className={clsx(styles.slider, styles.round)} />
      </label>
      <p className={styles.text}>{textBeforeTooltip}</p>
      <ClickAwayListener onClickAway={handleTooltipClose}>
        <Tooltip
          classes={{
            tooltip: styles.tooltip,
          }}
          PopperProps={{
            disablePortal: false,
          }}
          onClose={handleTooltipOpen}
          open={openTooltip}
          disableFocusListener
          disableHoverListener
          disableTouchListener
          TransitionComponent={Zoom}
          title={
            <>
              <div className={styles.hintText}>
                Подписка «Халва.Десятка» дает дополнительные преимущества вашей&nbsp;карте.
                Увеличенная рассрочка от&nbsp;10&nbsp;месяцев, повышенный кешбэк до&nbsp;10%. Первый
                месяц подписки – 0&nbsp;рублей, далее – 399&nbsp;рублей в&nbsp;мес.
                или&nbsp;3799&nbsp;руб. в&nbsp;год (скидка – 20%).
              </div>
              <IconButton onClick={handleTooltipClose} classes={{ root: styles.iconButtonRoot }}>
                <IconClose />
              </IconButton>
            </>
          }
        >
          <div className={styles.tooltipIcon} onClick={handleTooltipOpen} aria-hidden="true">
            <IconQuestion />
          </div>
        </Tooltip>
      </ClickAwayListener>
    </div>
  )
}
